export default __webpack_public_path__ + "static/media/triangle-exclamation.7fc8742c.svg";